<template>
    <div class="ticketDetail">
        <detail :goods_info="goods_details"></detail>
    </div>
</template>

<script>
import { Toast } from "mint-ui";
import detail from "../../components/markets/detail";
export default {
  name: "ticketDetail",
  data: function() {
    return {
      goods_id: this.$route.query.goods_id,
        goods_content: {}
    };
  },
  components: {
    detail
  },
  created: function() {
    this.getGoodsDetailsFunc();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "nav.online");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  mounted: function() {},
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    },
    goods_details: function() {
      return this.$store.state.market.goods_details;
    }
  },
  methods: {
    // 获取商品详情页的数据
    getGoodsDetailsFunc: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Goods/reservesInfo",
        dataType: "json",
        data: {
          id: this.$route.query.goods_id //商品id：goods_id
        }
      })
        .then(res => {
          if (res.data.status === 1) {
              // this.goods_content = res.data.result
            this.$store.commit("set_goods_details", res.data.result);
          } else {
            Toast(res.data.msg);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
</style>
